import styled from 'styled-components';

const Hours = styled.div`
    width: 80%;
    display:flex;
    flex-wrap: wrap;
    > button{
        margin-top: 7px;
        margin-bottom: 2px;
        padding: 7px 30px;
        font-size: 0.8em;
    }
`;

export default Hours;
